import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  lng: "fr",
  fallbackLng: "fr",
  debug: false,
  resources: {
    fr: {
      translation: require("../Locales/fr.json"),
    },
    en: {
      translation: require("../Locales/en.json"),
    },
  },
});

export default i18n;
